import styled from "styled-components";

export const CardHeading = styled.h2`
  margin: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 1rem;
  width: 100%;
  ${(props) => props.theme.media.medium} {
    flex-direction: row;
  }
`;
export const ProjectName = styled.div`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.1rem;
`;

export const ProgressBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${(props) => props.theme.gradients.light2};
  min-width: 200px;
  padding: 1rem;
  padding-top: 1.25rem;
  border-radius: 0.25rem;
  white-space: nowrap;
  font-weight: 500;
  strong {
    font-size: 28px;
    line-height: 36px;
  }
  ${(props) => props.theme.media.large} {
    min-width: 290px;
  }
`;

export const ProgressBar = styled.div<{ progress: number }>`
  margin-top: 0.7rem;
  background: ${(props) => props.theme.colors.lightest};
  width: 100%;
  height: 20px;
  border-radius: 10px;
  padding: 2px;
  &::after {
    content: "";
    display: block;
    height: 100%;
    width: ${(props) => props.progress}%;
    min-width: ${(props) => props.progress > 0 ? "16px" : "0"};
    background: ${(props) => props.theme.colors.dark};
    border-radius: 8px;
  }
`;

export const LinkWrapper = styled.div`
  align-self: center;
  justify-self: end;
  cursor: pointer;
`;
